import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Fusetree: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m345 390h-135v-180h30v150h105z' />
    <path d='m345 600h-135v-220h30v190h105z' />
    <path d='m660 240h-390v-30h360v-65c0-13.79-11.21-25-25-25h-455v90h30v30h-60v-150h485c30.33 0 55 24.67 55 55z' />
    <path d='m660 660h-330v-150h275c30.33 0 55 24.67 55 55zm-300-30h270v-65c0-13.79-11.21-25-25-25h-245z' />
    <path d='m660 450h-330v-150h275c30.33 0 55 24.67 55 55zm-300-30h270v-65c0-13.79-11.21-25-25-25h-245z' />
    <circle cx='580' cy='165' r='30' />
    <circle cx='580' cy='375' r='30' />
    <circle cx='580' cy='585' r='30' />
  </IconBase>
));

Fusetree.displayName = 'Fusetree';

export default Fusetree;
